import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarArticuloMenu = ({ show, onClose, restauranteId, onArticuloAgregado }) => {
    const [nuevoArticulo, setNuevoArticulo] = useState({
        nombre: "",
        descripcion: "",
        precio: "",
        categoria: "",
    });
    const [foto, setFoto] = useState(null); // Estado para almacenar la imagen seleccionada
    const [previewUrl, setPreviewUrl] = useState(null); // Estado para la URL de vista previa

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNuevoArticulo({ ...nuevoArticulo, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFoto(file); // Guardar la imagen seleccionada

        // Generar y almacenar la URL de vista previa de la imagen
        if (file) {
            setPreviewUrl(URL.createObjectURL(file));
        } else {
            setPreviewUrl(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nuevoArticulo.nombre || !nuevoArticulo.descripcion || !nuevoArticulo.precio || !nuevoArticulo.categoria || !foto) {
            alert("Todos los campos y la imagen son requeridos.");
            return;
        }

        try {
            // Subir la imagen primero
            const formData = new FormData();
            formData.append("file", foto);
            const uploadResponse = await clienteAxios.post("/api/documento", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            const fotoUrl = uploadResponse.data.file.filename; 

            // Enviar los datos del artículo
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "articulos_menu",
                restaurante_id: restauranteId,
                nombre: nuevoArticulo.nombre,
                descripcion: nuevoArticulo.descripcion,
                precio: nuevoArticulo.precio,
                categoria: nuevoArticulo.categoria,
                fotos: fotoUrl 
            });

            onArticuloAgregado(); // Refrescar la lista de artículos
            onClose(); // Cerrar el modal
        } catch (error) {
            console.error("Error al agregar artículo:", error);
        }
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Artículo</h2>

                <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
                    <div>
                        <label htmlFor="nombre" className="block font-semibold">Nombre</label>
                        <input
                            type="text"
                            id="nombre"
                            name="nombre"
                            value={nuevoArticulo.nombre}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Nombre del artículo"
                            maxLength={50}
                        />
                    </div>
                    <div>
                        <label htmlFor="descripcion" className="block font-semibold">Descripción</label>
                        <input
                            type="text"
                            id="descripcion"
                            name="descripcion"
                            value={nuevoArticulo.descripcion}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Descripción del artículo"
                            maxLength={50}
                        />
                    </div>
                    <div>
                        <label htmlFor="precio" className="block font-semibold">Precio</label>
                        <input
                            type="number"
                            id="precio"
                            name="precio"
                            value={nuevoArticulo.precio}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Precio del artículo"
                            maxLength={10}
                        />
                    </div>
                    <div>
                        <label htmlFor="categoria" className="block font-semibold">Categoría</label>
                        <input
                            type="text"
                            id="categoria"
                            name="categoria"
                            value={nuevoArticulo.categoria}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Categoría del artículo"
                            maxLength={50}
                        />
                    </div>
                    <div>
                        <label htmlFor="foto" className="block font-semibold">Foto</label>
                        <input
                            type="file"
                            id="foto"
                            name="foto"
                            onChange={handleFileChange}
                            className="border rounded-lg p-2 w-full"
                            accept="image/*" // Solo permitir imágenes
                        />
                    </div>

                    {/* Mostrar la vista previa de la imagen seleccionada */}
                    {previewUrl && (
                        <div className="mt-4">
                            <p className="font-semibold">Vista previa:</p>
                            <img
                                src={previewUrl}
                                alt="Vista previa"
                                className="w-32 h-32 object-cover mt-2 rounded-lg"
                            />
                        </div>
                    )}

                    <div className="flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white px-4 py-2 rounded"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-green-500 text-white px-4 py-2 rounded"
                        >
                            Agregar Artículo
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarArticuloMenu;
